import React from 'react'
import SignInIntro from '@components/Modals/SignIn/SignInIntro'

const SignInInputStep = () => {
    return <SignInIntro/>
}

export default SignInInputStep